import { API_BASE } from "../utils/baseapiurl";

/**
 * The imported cutoffs shown under the data-import uploader, and removing one.
 */
class ImportCutoffAPI {
	async list() {
		const response = await fetch(`${API_BASE}/imported-periods`, {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
				"X-WP-Nonce": window.wpApiSettings?.nonce || "",
			},
			credentials: "include",
		});

		const body = await response.json();

		if (!response.ok || body?.code) {
			throw new Error(body?.message || "Could not load the imported cutoffs.");
		}

		return body?.periods ?? [];
	}

	/**
	 * Remove one cutoff and everything computed from it. Irreversible.
	 *
	 * @param {string} period Cutoff as "YYYY-MM".
	 */
	async remove(period) {
		// Query string rather than a JSON body: WP only parses a request body for
		// DELETE under some configurations, and a query param is read the same way
		// by get_param() regardless.
		const params = new URLSearchParams({ period });

		const response = await fetch(`${API_BASE}/delete-period?${params}`, {
			method: "DELETE",
			headers: {
				"Content-Type": "application/json",
				"X-WP-Nonce": window.wpApiSettings?.nonce || "",
			},
			credentials: "include",
		});

		const body = await response.json();

		// The server's own words where it gave any — "No import found for 2026-07"
		// is actionable in a way a generic failure message is not.
		if (!response.ok || body?.code) {
			throw new Error(body?.message || "Could not delete that cutoff.");
		}

		return body?.result ?? {};
	}
}

export default new ImportCutoffAPI();
